import * as React from "react";
import { Alert, Card, Checkbox, Radio, Form, Tag } from "antd";
import { ITest, TestType } from "../common/types";

// styles
import "./index.css";

interface Props {
  test: ITest | any;
  id: number;
  submitted: boolean;
  results: boolean[];
}

const TestCard = ({ test, id, submitted, results }: Props) => {
  const radioStyle = {
    display: "block",
    height: "30px",
    lineHeight: "30px",
  };

  const TF = () => {
    return (
      <Form.Item name={id}>
        <Radio.Group>
          <Radio style={radioStyle} value="正">
            正
          </Radio>
          <Radio style={radioStyle} value="誤">
            誤
          </Radio>
        </Radio.Group>
      </Form.Item>
    );
  };

  const SelectOne = () => {
    return (
      <Form.Item name={id}>
        <Radio.Group>
          {test.options.map((option: string) => (
            <Radio value={option} key={option}>
              {option}
            </Radio>
          ))}
        </Radio.Group>
      </Form.Item>
    );
  };

  const SelectMulti = () => {
    return (
      <Form.Item name={id}>
        <Checkbox.Group
          options={test.options}
          onChange={(a) => console.log(a)}
        />
      </Form.Item>
    );
  };

  const renderSelection = (type: TestType) => {
    switch (type) {
      case "tf":
        return <TF />;
      case "select-one":
        return <SelectOne />;
      case "select-multi":
        return <SelectMulti />;
      default:
        return;
    }
  };

  const formatAnswer = (answer: string | string[]) => {
    return Array.isArray(answer) ? answer.join("】【") : answer;
  };
  const type = results[id] ? "success" : "error";
  const message = results[id] ? "正解" : "不正解";
  const description = results[id]
    ? test.description
    : `正解は【${formatAnswer(test.answer)}】です。${test.description}`;

  return (
    <>
      <Card title={test.title}>
        {test.question}
        <Card bordered={false}>{renderSelection(test.type)}</Card>
        {test.tags.map((tag: string) => (
          <Tag key={tag}>{tag}</Tag>
        ))}
      </Card>
      {submitted && (
        <Alert type={type} message={message} description={description} />
      )}
    </>
  );
};

export default TestCard;
